import { render, staticRenderFns } from "./PortfolioFilterLink.vue?vue&type=template&id=2c1894cc&scoped=true"
import script from "./PortfolioFilterLink.vue?vue&type=script&lang=js"
export * from "./PortfolioFilterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1894cc",
  null
  
)

export default component.exports